import React from 'react';
import { connect } from 'react-redux';
import { currentEpisodeActions, readingActions, signinActions } from '../../../actions';
import * as socialControlsActions from '../../../actions/socialControlsActions';
import * as formActions from '../../../actions/formActions';
import DropdownMenu from '../../design/DropdownMenu';
import ImgWithText from '../../design/ImgWithText';
import SlidingDrawer from '../../design/SlidingDrawer';
import { abbreviatedNumber } from '../../design/utilities';
import { YellowButton } from '../../design/buttons';
import { Content as ReportMenuContent, Footer as ReportMenuFooter } from '../../design/ReportMenu';
import { isNotLogged, goToLoginWithBackPath, saveAction, isLogged } from '../helpers';
import { withPaidCheck } from '../paidContentCheck';
import { List as PopCommentsList } from '../PopComments/List';
import Icons from './Icons';
import SocialControlsIconsDisabled from './SocialControlsIconsDisabled';
import { withDisabilityCheck } from "../disabilityContentCheck";

class SocialControls extends React.Component {

  componentDidMount () {
    if (sessionStorage.getItem('popcomics-webreader-add-comment') != null) {
      sessionStorage.removeItem('popcomics-webreader-add-comment');
      this.props.fetchDrawerContent('commentList', { episode_id: this.props.currentEpisode.id, page_number: this.props.paginationInfo.next_page});
      this.props.openDrawer('commentList');
    }
    if (sessionStorage.getItem('popcomics-webreader-like-comment') != null) {
      this.props.fetchDrawerContent('commentList', { episode_id: this.props.currentEpisode.id, page_number: this.props.paginationInfo.next_page});
      this.props.openDrawer('commentList');
    }
    if (sessionStorage.getItem('popcomics-webreader-reply-comment') != null) {
      this.props.fetchDrawerContent('commentList', { episode_id: this.props.currentEpisode.id, page_number: this.props.paginationInfo.next_page});
      this.props.openDrawer('commentList');
    }
    if (sessionStorage.getItem('popcomics-webreader-report-episode') != null) {
      sessionStorage.removeItem('popcomics-webreader-report-episode');
      this.props.fetchDrawerContent('reportMenu');
      this.props.openDrawer('reportMenu');
    }
  }

  twitterOnClick () {
    const twitterUrl = 'https://twitter.com/intent/tweet?lang=' + I18n.locale + '&text=' +
      I18n.t('components.episode_last_page.social_actions.twitter.text', {title: this.props.currentEpisode.title, by: this.props.currentEpisode.story_title}) +
      (I18n.locale !== 'en' ? this.props.currentEpisode.story_public_url.replace('story/', I18n.locale + '/story/') : this.props.currentEpisode.story_public_url
    );
    window.open(twitterUrl, '_blank', 'toolbar=0,location=0,menubar=0');
  }

  fbOnClick () {
    const storyUrl = this.props.story.public_url;
    const facebookUrl = (I18n.locale !== 'en' ? storyUrl.replace('story/', I18n.locale + '/story/') : storyUrl);
    FB.ui({ method: 'share', display: 'popup', href: facebookUrl },
    function (response) {
      if (response && !response.error_message) {
        setNoticeSuccess(I18n.t('components.episode_last_page.social_actions.fb.success'));
      } else {
        setNoticeError(I18n.t('components.episode_last_page.social_actions.fb.error'));
      }
    });
  }

  getCommentsCount () {
    return this.props.currentEpisode.episode && abbreviatedNumber(this.props.currentEpisode.episode.public_stats.pop_comments_count, 1)
  }

  submitReport = (event) => {
    event.preventDefault();
    this.props.submitReport(this.props.reportContext);
  }

  cancelReport = (event) => {
    event.preventDefault();
    this.props.closeDrawer();
  }

  handleKeyPress = (event) => {
    event.key === 'Enter' && this.submitNewComment(event)
  };

  submitNewComment = (event) => {
    event.preventDefault();
    let body = this.props.newCommentForm.body
    if (isNotLogged()) {
      this.goToLogin()
    } else {
      if (body != '') {
        this.props.submitNewComment(this.props.currentEpisode.id, body)
      } else {
        setNoticeError(I18n.t('components.webreader_comments_list').commentBlank);
      }
    }
  }

  loadMoreComments(isVisible) {
    if (isVisible && this.props.paginationInfo.next_page) {
      this.props.loadMoreComments(this.props.currentEpisode.id, this.props.paginationInfo.next_page)
    }
  }

  goToLogin() {
    saveAction('popcomics-webreader-add-comment', '');
    goToLoginWithBackPath();
  }

  handleClickOnInput () {
    if (isNotLogged()) {
      this.props.openSigninModalWithCallback(null, '', [null]);
    }
  }

  render () {
    const slidingDrawer = this.props.socialControls.slidingDrawer;
    const { socialControls, t } = this.props;

    let drawerContent = null;
    if (this.props.socialControls.slidingDrawer.currentContent === 'reportMenu') {
      drawerContent = <ReportMenuContent categories={this.props.socialControls.slidingDrawer.content} selectAction={this.props.selectReportCategory}/>
    } else if (this.props.socialControls.slidingDrawer.currentContent === 'commentList') {
      drawerContent = <PopCommentsList comments={this.props.current_episode_comments} loadMoreComments={this.loadMoreComments.bind(this)}/>
    }

    return (
      <div className="webreader-social-controls">
        <div className="right relative">
          <Icons />

          <DropdownMenu width='221px' opened={this.props.socialControls.socialsOpened}>
            <ImgWithText img='/images/facebook.png' text='Facebook' onClick={this.fbOnClick.bind(this)} />
            <ImgWithText img='/images/twitter.png'  text='Twitter'  onClick={this.twitterOnClick.bind(this)} />
          </DropdownMenu>
        </div>
        <SlidingDrawer
          className={slidingDrawer.currentContent}
          opened={slidingDrawer.opened}
          title={
            slidingDrawer.currentContent === 'reportMenu'
              ? t.title
              : `${I18n.t('components.webreader_comments_list.comments_count')} (${this.getCommentsCount()})`
          }
          loading={this.props.socialControls.slidingDrawer.fetching === true}
          onClick={this.props.closeDrawer}
          actionBar={
            slidingDrawer.currentContent === 'reportMenu'
              ? <ReportMenuFooter
                submitTranslation={t.send}
                cancelTranslation={t.cancel}
                submitAction={this.submitReport}
                cancelAction={this.cancelReport}
                />
              : <div className='a-post-comment-container'>
                <input className='bg-yellow-3 a-post-comment-input'
                  type='text'
                  placeholder={I18n.t('components.webreader_comments_list.write_comment_placeholder')}
                  onClick={this.handleClickOnInput.bind(this)}
                  onChange={(event) => { this.props.updateNewCommentBody(event.target.value); }}
                  onKeyPress={this.handleKeyPress}
                  value={this.props.newCommentForm.body}
                />
                <YellowButton
                  text={I18n.t('components.webreader_comments_list.submit_comment')}
                  onClick={this.submitNewComment.bind(this)}
                />
              </div>
          }
        >
          {drawerContent}
        </SlidingDrawer>
      </div>
    );
  }
}

const mapState = (state, ownProps) => {
  let t = I18n.t('components.webreader_reports_menu');
  return {
    t: t,
    socialControls:  state.socialControls,
    currentEpisode:  state.currentEpisode,
    current_episode_comments: state.current_episode_comments,
    story:           state.story,
    paginationInfo:  state.socialControls.slidingDrawer.commentsList.paginationInfo,
    showPoppins:     state.reading.showPoppins,
    reportContext: {
      violation_category_id: state.socialControls.slidingDrawer.reportMenu.selectedCategoryId,
      story_id: state.currentEpisode.story_id,
      episode_id: state.currentEpisode.id,
      violationReported: t.violationReported,
      noCategorySelected: t.noCategorySelected
    },
    newCommentForm: state.newCommentForm
  };
};

const mapDispatch = (dispatch, ownProps) => ({
  fetchDrawerContent:          (type, data) => { dispatch(socialControlsActions.fetchDrawerContent(type, data)) },
  openDrawer:                        (type) => { dispatch(socialControlsActions.openDrawer(type)) },
  closeDrawer:                           () => { dispatch(socialControlsActions.closeDrawer()) },
  submitReport:             (reportContext) => { dispatch(socialControlsActions.submitReport(reportContext)) },
  selectReportCategory:                (id) => { dispatch(socialControlsActions.selectReportCategory(id)) },
  loadMoreComments: (episodeId, pageNumber) => { dispatch(socialControlsActions.loadMoreComments(episodeId, pageNumber)) },
  updateNewCommentBody:              (body) => { dispatch(formActions.updateNewCommentBody(body)) },
  submitNewComment:       (episodeId, body) => { dispatch(formActions.submitNewComment(episodeId, body)) },
  toggleLike:                   (episodeId) => { dispatch(currentEpisodeActions.episodeToggleLike(episodeId)) },
  poppinsShow:                           () => { dispatch(readingActions.poppinsShow()) },
  // openSigninModal:                       () => { dispatch(signinActions.openModal()) }
  openSigninModalWithCallback: (callback, callbackType, callbackArgs) => {
    dispatch(signinActions.openModalWithCallback(callback, callbackType, callbackArgs));
  },

});

const SocialControlsEnabled = connect(mapState, mapDispatch)(SocialControls);
const AuthorizedSocialControls = withPaidCheck(SocialControlsEnabled, SocialControlsIconsDisabled);
const CheckedSocialControls = withDisabilityCheck(AuthorizedSocialControls, SocialControlsIconsDisabled);
export default CheckedSocialControls;
